import { render, staticRenderFns } from "./Huji.vue?vue&type=template&id=3b705a41"
import script from "./Huji.vue?vue&type=script&lang=js"
export * from "./Huji.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports